<template>
  <div>
    <div v-if="data.length > 0" class="main-sp">
      <div class="categorias">LISTA DE PEÇAS DE REPOSIÇÃO DO MOLDE</div>
      <div class="spare-parts">
        <table>
          <thead>
            <tr>
              <th>Item</th>
              <th>Descrição</th>
              <th>Quantidade</th>
              <th>Observações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="l in data" :key="l.ID">
              <td class="td-center">
                <div class="img-exp">
                  <div>
                    <img
                      alt="Não Aplicável"
                      :src="this.$store.state.ImgURL + l.PATH_IMG + '.webp'"
                    />
                  </div>
                </div>
              </td>
              <td>{{ l.DESCRIPTION }}</td>
              <td>{{ l.QUANTIDADE }}</td>
              <td>{{ l.OBSERVACAO }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-else class="main-alert">
      <div class="alert-sp">
        O MOLDE NÃO ACOMPANHA SPARE PARTS
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: []
  }
};
</script>

<style>
/* Seu CSS atual permanece aqui, se houver */
</style>